module.exports = __webpack_public_path__ + "img/bitmap.ed489622.jpg";